'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { useAppSelector } from '@/redux/hooks';

export const PostHogIdentitySync = () => {
  const userSession = useAppSelector(state => state.user.userSession);
  const { data: user } = useUserMeQuery();
  const { id, email, createdAt } = user ?? {};

  useEffect(() => {
    if (!userSession || !id) {
      return;
    }

    let identified = false;
    const identify = () => {
      if (identified || !window.Cookiebot?.consent?.statistics) {
        return;
      }

      posthog.identify(id, { email, registration_date: createdAt });
      posthog.createPersonProfile?.();
      identified = true;
    };

    window.addEventListener('CookiebotOnLoad', identify);
    window.addEventListener('CookiebotOnAccept', identify);
    window.addEventListener('CookieConsentDeclaration', identify);
    identify();

    return () => {
      window.removeEventListener('CookiebotOnLoad', identify);
      window.removeEventListener('CookiebotOnAccept', identify);
      window.removeEventListener('CookieConsentDeclaration', identify);
    };
  }, [userSession, id, email, createdAt]);

  return null;
};
